import { COMMON_CONSTANTS, DATE_FORMAT } from '@nile/components';
import dayjs from 'dayjs';

function getClientSiteVariablesById(id) {
  if (id) {
    // get sites based on clientId
    return {
      input: {
        sort: [
          {
            attribute: 'name',
            order: 'ASC'
          }
        ],
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              value: id,
              operator: 'is',
              attribute: 'account.accountId'
            }
          ]
        }
      }
    };
  }
  // to get all sites list
  return {
    input: {
      sort: [
        {
          attribute: 'name',
          order: 'ASC'
        }
      ]
    }
  };
}
function getTechnicianVariables(props) {
  const { clientIds, siteIds, isListInfoRequired, currentProduct } = props;
  const isMSPProduct = currentProduct === COMMON_CONSTANTS.MSP;
  const orgData = {
    input: {}
  };
  if (isListInfoRequired) {
    orgData.input.listInfo = {
      sort: {
        attribute: 'name',
        order: 'ASC'
      }
    };
  }
  if (isMSPProduct) {
    orgData.input.forOrganizations = clientIds?.map((item) => {
      return { accountId: item };
    });
    return orgData;
  }
  if (siteIds) {
    orgData.input.forSites = siteIds?.map((item) => {
      return { id: item };
    });
    return orgData;
  }
  return orgData;
}
const addCondition = (condition, attribute, value) => {
  if (value) {
    condition.operands.push({
      attribute,
      operator: 'is',
      value
    });
  }
};
function getClientUserAssociationListVariables(props) {
  const clientCondition = { joinOperator: 'AND', operands: [] };
  const { clientId, siteId, departmentId, currentProduct } = props;

  const isMSPProduct = currentProduct === COMMON_CONSTANTS.MSP;
  if (isMSPProduct) {
    addCondition(clientCondition, 'client.accountId', clientId);
  } else {
    addCondition(
      clientCondition,
      'user.businessFunction.businessFunctionId',
      departmentId
    );
  }
  addCondition(clientCondition, 'site.id', siteId);
  return {
    input: {
      listInfo: {
        sort: [
          {
            attribute: 'user.name',
            order: 'ASC'
          }
        ],
        condition: clientCondition.operands.length ? clientCondition : null
      }
    }
  };
}

function getClientContractsVariables(id, siteId) {
  return {
    listInfo: {
      condition: {
        joinOperator: 'AND',
        operands: [
          {
            attribute: 'client.accountId',
            operator: 'is',
            value: id
          },
          {
            joinOperator: 'OR',
            operands: [
              {
                attribute:
                  'contract.billableContract.contractSiteMapping.siteId',
                operator: 'isEmpty'
              },
              {
                attribute:
                  'contract.billableContract.contractSiteMapping.siteId',
                operator: 'is',
                value: siteId
              }
            ]
          },
          {
            joinOperator: 'OR',
            operands: [
              {
                joinOperator: 'AND',
                operands: [
                  {
                    attribute: 'startDate',
                    operator: 'lessThanOrEqual',
                    value: dayjs(new Date()).format(DATE_FORMAT)
                  },
                  {
                    attribute: 'contract.contractType',
                    operator: 'includes',
                    value: ['SERVICE']
                  },
                  {
                    attribute:
                      'contract.billableContract.chargeItem.serviceTypeItem.offeringType',
                    operator: 'notIncludes',
                    value: ['BLOCK_HOUR', 'BLOCK_MONEY']
                  }
                ]
              },
              {
                joinOperator: 'AND',
                operands: [
                  {
                    attribute: 'contractStatus',
                    operator: 'is',
                    value: 'ACTIVE'
                  },
                  {
                    attribute:
                      'contract.billableContract.chargeItem.serviceTypeItem.offeringType',
                    operator: 'includes',
                    value: ['BLOCK_HOUR', 'BLOCK_MONEY']
                  }
                ]
              }
            ]
          },
          {
            attribute: 'contractStatus',
            operator: 'isNot',
            value: 'INACTIVE'
          }
        ]
      }
    }
  };
}
export {
  getClientSiteVariablesById,
  getTechnicianVariables,
  getClientUserAssociationListVariables,
  getClientContractsVariables
};
